(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cstm-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.cstm-product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

 document.body.addEventListener("click", function (e) { 
  var swatch = e.target.closest('.product-block-options__item');
  
  if (swatch) {
    e.preventDefault();
    var mediaId = swatch.dataset.media;
    var variantId = swatch.dataset.id;
    var slides = document.querySelectorAll('.product-recommendations-wrapper .product-media-container');
    slides.forEach(function(slide) {
      slide.setAttribute('hidden', '');
      slide.setAttribute('aria-hidden', 'true');
    });
    var targetSlide = document.querySelector('.product-recommendations-wrapper .product-media-container[slide-id="'+mediaId+'"]');
    document.querySelector('product-recommendations').querySelector('product-form-component [name="id"]').value = variantId;
    if (targetSlide) {
      targetSlide.removeAttribute('hidden');
      targetSlide.setAttribute('aria-hidden', 'false');
    }
  }
  var moreLabel = e.target.closest('.product-block-options__more-label');
  var allHidden = document.querySelectorAll('.product-block-options .product-block-options__item');
  if(moreLabel){
      allHidden.forEach(function(hiddenEl){
        hiddenEl.classList.remove('hide-swatches');
        moreLabel.style.display = 'none';
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
